import { render } from "./Errors.vue?vue&type=template&id=3d358139"
import script from "./Errors.vue?vue&type=script&setup=true&lang=js"
export * from "./Errors.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Form/Errors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d358139"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d358139', __exports__)) {
    api.reload('3d358139', __exports__)
  }
  
  module.hot.accept("./Errors.vue?vue&type=template&id=3d358139", () => {
    api.rerender('3d358139', render)
  })

}


export default __exports__